// src/app/services/router-change.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import *  as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class MenuRightsService {
    constructor(private router: Router,
        private activatedRoute: ActivatedRoute) {

        this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.destroy$)).subscribe(() => { this.getMeuDetails(); });

    }

    private destroy$ = new Subject<void>();

    private HeaderTitle = new BehaviorSubject<string>('');
    getHeader = this.HeaderTitle.asObservable();

    private menuDataSubject = new BehaviorSubject<any>({});
    menuData$: Observable<any> = this.menuDataSubject.asObservable();

    getMeuDetails() {
        const routeData = this.getChildRouteData(this.activatedRoute);

        
        if (routeData && routeData['menu_id']) {

            const d: any = localStorage.getItem('currentUser');
            const user: any = JSON.parse(d).user;
            const menu = _.filter(user.menu_list, { unique_id: routeData['menu_id'] });
            const final_data = menu[0] ? menu[0] : {};
            
            this.menuDataSubject.next(final_data);
        }

    }

    private getChildRouteData(route: ActivatedRoute): any {
        if (route.firstChild) {
            return this.getChildRouteData(route.firstChild);
        }
        return route.snapshot.data;
    }


}
